<template>
  <div class="fence">
    <!-- 百度地图 -->
    <ZXBaiMap
      @getMap="getMap"
    />
  </div>
</template>
<script>
import moment from 'moment'
import {TransForm} from '@/assets/js/transform'
import ZXBaiMap from '@/components/common/BMap.vue'
import iconUrl from '../../assets/person.png'
import {transToBD09} from '../../utils/globalFunction'
export default {
  components: {
    ZXBaiMap
  },
  props: {
    alarmData: {
      required: true
    }
  },
  data () {
    return {
      // 百度地图的地图实例
      map: undefined,
      overlays: [],
      styleOptions: {
        //边线颜色。
        strokeColor:"red",
        //填充颜色。当参数为空时，圆形将没有填充效果   
        fillColor:"red",
        //边线的宽度，以像素为单位    
        strokeWeight: 3,
        //边线透明度，取值范围0 - 1     
        strokeOpacity: 0.7,
        //填充的透明度，取值范围0 - 1	   
        fillOpacity: 0.4,
        //边线的样式，solid或dashed    
        strokeStyle: 'solid'
      },
      points: []
    }
  },
  methods: {
    getMap (map) {
      // 获取到地图实例
      this.map = map
      if (this.alarmData.attr) {
        // 在地图上画出电子围栏
        // console.log(this.alarmData.attr)
        let mapData = typeof this.alarmData.attr === 'string' ? JSON.parse(this.alarmData.attr) : this.alarmData.attr
        // let mapData = this.alarmData.attr
        this.alarmData.attr = mapData
        // 根据围栏类型确定围栏颜色
        this.computedFenceColor(mapData.opt)
        this.drawFence(mapData)
        // 画出人物
        // console.log(this.alarmData)
        let bd09Point = this.transToBd09(this.alarmData.coordType, this.alarmData.lng, this.alarmData.lat)
        let point = new BMap.Point(bd09Point.lng, bd09Point.lat)
        // console.log(point)
        this.drawPerson(point, this.alarmData)
        this.points.push(point)
        // console.log(this.points)
        // 调整地图视口区域
        // this.map && this.map.setViewport(this.points)
        this.$nextTick().then(() => {
          this.map && this.map.setViewport(this.points, {
            margins: [100, 100, 100, 100]
          })
        })
      }
    },
    computedFenceColor (opt) {
      if (opt === 1) {
        this.styleOptions.strokeColor = 'red'
        this.styleOptions.fillColor = 'red'
      } else if (opt === 2) {
        this.styleOptions.strokeColor = 'green'
        this.styleOptions.fillColor = 'green'
      }
    },
    drawFence (mapData) {
      this.mapData = mapData
      // console.log(this.mapData)
      this.drawInitFence()
    },
    drawPerson (point, alarmData) {
      // 创建一个人物marker
      // let point = {}
      let PersonIcon = new BMap.Icon(iconUrl, new BMap.Size(32, 32), {
        anchor: new BMap.Size(12, 32)
      })
      let markerOptions = {
        icon: PersonIcon
      }
      let personMarker = new BMap.Marker(point, markerOptions)
      // console.log(alarmData)
      // 将这个marker添加到地图上
      this.map && this.map.addOverlay(personMarker)
      // 添加说明窗口
      let personInfoWindow = new BMap.InfoWindow(`
        <p>${alarmData.uniqueSign || alarmData.entity}</p>
        <p>${this.$t('supervise.fenceType')}:${alarmData.attr.opt === 1 ? this.$t('global.forbidIn') : this.$t('global.forbidOut')}</p>
        <p>${moment(alarmData.occurTime * 1000).format('YYYY-MM-DD HH:mm')}</p>
      `, {
        enableCloseOnClick: false,
        offset: new BMap.Size(0, -32)
      })
      // 定义一个变量标识信息窗口是否是关闭状态
      let isClosedInfoWindow = false
      // 默认添加信息窗口
      personMarker.openInfoWindow(personInfoWindow)
      // infoWindow事件监听 窗口被关闭
      personInfoWindow.addEventListener('close', (ev) => {
        // console.log(ev)
        // 改变状态
        isClosedInfoWindow = true
      })
      // 添加人物点击监听
      personMarker.addEventListener('click', (ev) => {
        // console.log(ev)
        // 当信息窗口是关闭状态的话就打开信息窗口
        if (isClosedInfoWindow === true) {
          // console.log(personInfoWindow.isOpen())
          // 打开信息窗口
          // personInfoWindow.restore()
          personMarker.openInfoWindow(personInfoWindow)
          // 改变状态
          isClosedInfoWindow = false
        }
      })
    },
    // 初始化时绘制围栏
    drawInitFence () {
      // 绘制图形
      if (this.mapData.parameter) {
        // console.log(this.mapData)
        let overlay = this.drawPattern(this.mapData.type)
        if (this.mapData.type === 'district') {
          for (let i = 0; i < overlay.length; i++) {
            this.map.addOverlay(overlay[i])
            this.overlays.push(overlay[i])
          }
        } else {
          this.map.addOverlay(overlay)
          this.overlays.push(overlay)
        }
      }
    },
    // 绘制图形
    drawPattern (type) {
      if (type) {
        let pattern = {
          'polygon': () => {
            // 获取所有点坐标
            let points = []
            // console.log(this.mapData.parameter)
            for (let i = 0; i < this.mapData.parameter.points[0].length; i++) {
              points.push(new BMap.Point(...this.formatMapPoint(this.mapData.parameter.points[0][i])))
            }
            // console.log(points)
            let polygon = new BMap.Polygon(points, this.styleOptions)
            this.points = points
            return polygon
          },
          'district': () => {
            let points = []
            let overlays = []
            // console.log(this.mapData)
            for (let i = 0; i < this.mapData.parameter.points.length; i++) {
              // 为解决行政区可能有多个区域，需先定义每个坐标容器 []
              // 当然也可以用 points[i] = [...points[i], new xxxxxxxxx]这样的思路解决问题
              points[i] = []
              for (let j = 0; j < this.mapData.parameter.points[i].length; j++) {
                // debugger
                points[i].push(new BMap.Point(...this.formatMapPoint(this.mapData.parameter.points[i][j])))
              }
              this.points = [...this.points, ...points[i]]
              overlays.push(new BMap.Polygon(points[i], this.styleOptions))
            }
            // console.log(this.points)
            // console.log(overlays)
            // let polygon = new BMap.Polygon(points[i], this.styleOptions)
            return overlays
          },
          'circle': () => {
            let center = new BMap.Point(...this.getMapCenterPoint())
            // console.log(center)
            // console.log(this.mapData)
            let circle = new BMap.Circle(center, this.mapData.parameter.radius, this.styleOptions)
            // console.log(circle)
            let points = []
            let radius = this.mapData.parameter.radius
            points.push(new BMap.Point(center.lng, center.lat + radius/100000))
            points.push(new BMap.Point(center.lng, center.lat - radius/100000))
            points.push(new BMap.Point(center.lng + radius/100000, center.lat))
            points.push(new BMap.Point(center.lng - radius/100000, center.lat))
            this.points = points
            return circle
          }
        }
        return pattern[type]()
      }
    },
    formatMapPoint (point) {
      return [point.lng, point.lat]
    },
    // 获取创建地图的中心点坐标
    getMapCenterPoint () {
      // console.log(this.mapData)
      if (this.mapData.coordType) {
        this.mapData.parameter.points.forEach((pointsItem, i) => {
          pointsItem.forEach((point, j) => {
            let transedPoint = transToBD09(this.mapData.coordType, point.lng, point.lat)
            this.mapData.parameter.points[i][j].lng = transedPoint.lng
            this.mapData.parameter.points[i][j].lat = transedPoint.lat
          })
        })
        this.mapData.coordType = 'bd09'
      }
      if (this.mapData) {
        // 圆和其他类型需分开处理
        if (this.mapData.type === 'circle') {
          // console.log(this.mapData.parameter.points[0][0])
          return [this.mapData.parameter.points[0][0].lng, this.mapData.parameter.points[0][0].lat]
        } else {
          // ...
          // console.log(this.mapData)
          // debugger
          let latSum = 0
          let lngSum = 0
          for (let i = 0; i < this.mapData.parameter.points[0].length; i++) {
            latSum += this.mapData.parameter.points[0][i].lat
            lngSum += this.mapData.parameter.points[0][i].lng
          }
          let center = [(lngSum / this.mapData.parameter.points[0].length).toFixed(6), (latSum / this.mapData.parameter.points[0].length).toFixed(6)]
          // console.log(center)
          return center
        }
      }
    },
    // 坐标转换
    transToBd09(coord_type, lng, lat) {
      let tmpLat = +lat
      let tmpLng = +lng
      let tmp
      if (coord_type == 'wgs84' || coord_type == 'WGS84') {
          tmp = TransForm.wgs84tobd09(tmpLng, tmpLat)
      } else if (coord_type == 'gcj02' || coord_type == 'GCJ02') {
          tmp = TransForm.gcj02tobd09(tmpLng, tmpLat)
      } else {
          tmp = [tmpLng, tmpLat]
      }
      tmp = [tmp[0].toFixed(6), tmp[1].toFixed(6)]
      // return tmp
      return {
        coord_type: 'BD09',
        lng: tmp[0],
        lat: tmp[1]
      }
    },
  }
}
</script>
<style lang="less" scoped>

</style>
